import { Component, OnInit, Output, EventEmitter } from '@angular/core'
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { PlacementService } from '../../_services/placementservice';
import { MediaObserver } from '@ngbracket/ngx-layout';
import { Subject } from 'rxjs';
import { CrmUserAccount } from '../../_models';

@Component({
    selector: 'crm-user-select',
    templateUrl: 'crm.user.component.html',
    styleUrls: ['crm.user.component.css'],
    standalone: false
})

export class CrmUserComponent implements OnInit {
  
  @Output() onSelectedItemChanged: EventEmitter<any> = new EventEmitter<any>(); 

  public frmCrmUser: UntypedFormGroup;
  public users: Array<CrmUserAccount> = [];
  public filteredUsers: Array<CrmUserAccount> = [];
  public selectedAllUsers: boolean = false;
  public UserData = new Subject<boolean>();
  private prevUserSelection: CrmUserAccount[] = [];

  constructor(private formBuilder: UntypedFormBuilder,
    private placementService: PlacementService,
    public media: MediaObserver ) {
  }
  
  ngOnInit() {
    this.frmCrmUser = this.formBuilder.group({
      user: null
    });
    
    var currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.placementService.GetCrmUserAccounts().subscribe((data: CrmUserAccount[]) => {
      this.users = data;
      this.users.splice(0, 0, {id: 0, userFullName: "All", clientId:0,email:"",firstName:"",surName:"",tutorMobile:"",userRelationshipId:0});
      this.filteredUsers = this.users;
      var currUser = this.users.filter(x => x.email === currentUser.email);
      this.frmCrmUser.get("user").setValue(currUser);
      this.prevUserSelection = currUser ? [...currUser] : [];
      this.UserData.next(true);
    });
  }

  public reset() {
    this.frmCrmUser.controls.user.patchValue([]);
    var currentUser = JSON.parse(localStorage.getItem('currentUser'));
    var currUser = this.users.filter(x => x.email === currentUser.email);
    this.frmCrmUser.get("user").setValue(currUser);
    this.prevUserSelection = currUser ? [...currUser] : [];
    this.selectedAllUsers = false;
    return this.frmCrmUser.value.user;
  }

  public onUsersChanged(selected: CrmUserAccount[]): void {
    selected = selected || [];
    const hasAll = selected.some(u => u && u.id == 0);
    const hadAll = this.prevUserSelection.some(u => u && u.id == 0);

    if (hasAll && !hadAll) {
      // "All" was just selected → select every user (including the All option)
      selected = [...this.users];
      this.frmCrmUser.controls.user.setValue(selected);
    } else if (!hasAll && hadAll) {
      // "All" was just deselected → clear the selection
      selected = [];
      this.frmCrmUser.controls.user.setValue(selected);
    } else if (hasAll && hadAll && selected.length !== this.users.length) {
      // a specific user was toggled while "All" was active → drop the All option
      selected = selected.filter(u => !(u && u.id == 0));
      this.frmCrmUser.controls.user.setValue(selected);
    }

    this.prevUserSelection = [...selected];
    this.selectedAllUsers = selected.some(u => u && u.id == 0);

    var uData = new UserData();
    uData.selectedAllUsers = this.selectedAllUsers;
    uData.user = this.frmCrmUser.controls.user.value;
    this.onSelectedItemChanged.emit(uData);
  }

  public setUsers(data) {
    if (data !== null) {
      let selectedUsers = [];
      this.users.forEach((x) => data.forEach((d) => {
        if (x.id === d.id) {
          selectedUsers.push(x);
        }
      }))
      this.frmCrmUser.get("user").setValue(selectedUsers);
      this.prevUserSelection = [...selectedUsers];
    }
  }
  
  public filterUsers(result: Array<any>): void {
    this.filteredUsers = new Array<CrmUserAccount>();
    let userHolder = this.frmCrmUser.controls.user.value;
    if (userHolder !== null && userHolder.length > -1) {
      this.filteredUsers.push(...userHolder);
      result = result.filter(r => !userHolder.includes(r));
    }
    this.filteredUsers.push(...result);
  }
}

export class UserData {
  user: any[];
  selectedAllUsers: boolean = false;
}
